/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UseFormReset } from 'react-hook-form';

import { getGlobalLetter } from '../api';

import { GlobalLetterForm } from './use-global-letter.form';

type UseGetGlobalLetter = {
  reset: UseFormReset<GlobalLetterForm>;
};

export const useGetGlobalLetter = ({ reset }: UseGetGlobalLetter) => {
  const globalLetterQuery = useQuery<any[]>({
    queryKey: ['globalLetter'],
    // @ts-expect-error malformed data
    queryFn: getGlobalLetter,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (
      globalLetterQuery.isError ||
      globalLetterQuery.isFetched === false ||
      globalLetterQuery.data === undefined
    )
      return;
    // @ts-expect-error malformed data
    reset(globalLetterQuery.data);
  }, [
    globalLetterQuery.isError,
    globalLetterQuery.isFetched,
    globalLetterQuery.data,
    reset,
  ]);

  return globalLetterQuery;
};
